// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReasonCodeResponseDto } from './IReasonCodeResponseDto';
import {
    IReasonCodeResponseDtoFromJSON,
    IReasonCodeResponseDtoFromJSONTyped,
    IReasonCodeResponseDtoToJSON,
    IReasonCodeResponseDtoToJSONTyped,
} from './IReasonCodeResponseDto';

/**
 * 
 * @export
 * @interface IAchReturnResponseDto
 */
export interface IAchReturnResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IAchReturnResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAchReturnResponseDto
     */
    individual_identification_number?: string;
    /**
     * 
     * @type {Set<IReasonCodeResponseDto>}
     * @memberof IAchReturnResponseDto
     */
    return_reason_codes?: Set<IReasonCodeResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof IAchReturnResponseDto
     */
    ach_file_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IAchReturnResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IAchReturnResponseDto
     */
    received_on?: Date;
}

/**
 * Check if a given object implements the IAchReturnResponseDto interface.
 */
export function instanceOfIAchReturnResponseDto(value: object): value is IAchReturnResponseDto {
    return true;
}

export function IAchReturnResponseDtoFromJSON(json: any): IAchReturnResponseDto {
    return IAchReturnResponseDtoFromJSONTyped(json, false);
}

export function IAchReturnResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAchReturnResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'individual_identification_number': json['individual_identification_number'] == null ? undefined : json['individual_identification_number'],
        'return_reason_codes': json['return_reason_codes'] == null ? undefined : (new Set((json['return_reason_codes'] as Array<any>).map(IReasonCodeResponseDtoFromJSON))),
        'ach_file_name': json['ach_file_name'] == null ? undefined : json['ach_file_name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'received_on': json['received_on'] == null ? undefined : (new Date(json['received_on'])),
    };
}

export function IAchReturnResponseDtoToJSON(json: any): IAchReturnResponseDto {
    return IAchReturnResponseDtoToJSONTyped(json, false);
}

export function IAchReturnResponseDtoToJSONTyped(value?: IAchReturnResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'individual_identification_number': value['individual_identification_number'],
        'return_reason_codes': value['return_reason_codes'] == null ? undefined : (Array.from(value['return_reason_codes'] as Set<any>).map(IReasonCodeResponseDtoToJSON)),
        'ach_file_name': value['ach_file_name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'received_on': value['received_on'] == null ? undefined : ((value['received_on']).toISOString()),
    };
}

